export const MANAGED_KEY = {
  club: 1,
  user: 2,
  me: 3,
};

export default {
  MANAGED_KEY,
};
